// src/components/PageWrapper.jsx
import React, { useCallback } from 'react';
import SharedHeader from '../common/SharedHeader';
import Sidebar from './Sidebar';

const PageWrapper = ({ children, backgroundClass, style, isSidebarOpen, setIsSidebarOpen, setCurrentPage }) => {
  const handleToggleSidebar = useCallback(() => {
    if (typeof setIsSidebarOpen === 'function') {
      setIsSidebarOpen(prev => !prev);
    } else {
      console.error("Error: setIsSidebarOpen prop in PageWrapper is not a function. Current value:", setIsSidebarOpen);
    }
  }, [setIsSidebarOpen]);

  return (
    <div
      className={`page-wrapper w-full min-h-screen overflow-hidden ${backgroundClass || ''}`}
      style={{
        background: '#271834',
        ...style,
        maxWidth: '100vw',
        overflowX: 'hidden',
        boxSizing: 'border-box',
      }}
    >
      <SharedHeader
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        setCurrentPage={setCurrentPage}
      />
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={handleToggleSidebar}
        setCurrentPage={setCurrentPage}
      />
      <div className="relative flex-grow flex flex-col overflow-y-auto pt-[50px]">
        {children}
      </div>
    </div>
  );
};

export default PageWrapper;